import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'gatsby'
import "./Location.scss"

const Location = ({ data }) => {
  return (
      <div className="container location-wrapper">
        <h2 className="title-component">
          {data.title}
        </h2>
        <div className="locations-container row justify-content-around">
          {data?.buildingsLocation.map((location, i) => (
            <div className="location-card col-12 col-md-4" key={`location-id${i}`}>
              <div className="card-content">
                <FontAwesomeIcon
                  icon={['fas', 'map-marker-alt']}
                  size="2x"
                  className="icon"
                />
                <div className="text-center">
                  <h5 className="location-title">
                    {location.buildingName}
                  </h5>
                </div>
                <p className="location-info">{location.information}</p>
                <Link to={location.url} target="_blank">
                  <button className="location-button">
                    VER MAPA
                  </button>
                </Link>
              </div>  
            </div>
          ))}
        </div>
      </div>
  )
}

export default Location

Location.propTypes = {
  data: PropTypes.object.isRequired
}